export default "__VITE_ASSET__KWTOCHqi__"